import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { PdfShell } from "@/features/shell/PdfShell";
import { PdfPage } from "@/features/pdf/PdfPage";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <PdfShell />
        </ProtectedRoute>
    );
}

export function App() {
    return (
        <>
            <Routes>
                <Route path="/auth/callback" element={<CallbackPage />} />
                <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
                <Route element={<ProtectedShell />}>
                    <Route path="/" element={<PdfPage />} />
                </Route>
            </Routes>
            <AppCopyright />
        </>
    );
}

function AppCopyright() {
    // Same subtle, theme-aware corner credit as Docs and Sheets — the old
    // white box stood out in dark mode.
    return (
        <div className="pointer-events-none fixed bottom-1 right-2.5 z-[9999] select-none text-[10px] leading-none text-muted-foreground/60">
            © {new Date().getFullYear()} TribeX INC
        </div>
    );
}
